import { format } from 'date-fns/format';

export const formatRange = (range: [Date, Date] | null) => {
  if (!range) {
    return '—';
  }

  const [start, end] = range;
  return `${format(start, 'MMM d HH:mm')} - ${format(end, 'MMM d HH:mm')}`;
};

export const toDP = (value: number, places: number) =>
  value.toLocaleString(undefined, {
    minimumFractionDigits: places,
    maximumFractionDigits: places,
  });

export const randomID = () => Math.random().toString(36).slice(2);

export const joinWithAnd = (arr: string[]) => {
  if (arr.length === 0) {
    return '';
  }

  if (arr.length === 1) {
    return arr[0];
  }

  if (arr.length === 2) {
    return arr.join(' and ');
  }

  return `${arr.slice(0, -1).join(', ')}, and ${arr[arr.length - 1]}`;
};
